import { render, staticRenderFns } from "./BacklinksTable.vue?vue&type=template&id=9293864a&scoped=true&lang=html"
import script from "./BacklinksTable.vue?vue&type=script&lang=js"
export * from "./BacklinksTable.vue?vue&type=script&lang=js"
import style0 from "./BacklinksTable.vue?vue&type=style&index=0&id=9293864a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9293864a",
  null
  
)

export default component.exports